import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ImpressaoHTMLtoPDF } from 'src/app/@shared/models/impressao/impressao.model';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ImpressaoManifestoService {

  constructor(private http: HttpClient) { }

  selecionarDados(obj: any): Observable<any> {
    return this.http.post<any>(`ImpressaoDocumentos/DadosImpressao`, obj,  httpOptions);
  }

  public downloadPDF(obj: any): Observable<any> {

    return this.http.post(`ImpressaoDocumentos/DownloadPDF`, obj, httpOptions);
  }

  public imprimir(obj: any): Observable<any> {
    return this.http.post(`ImpressaoDocumentos/Imprimir`, obj, httpOptions);
  }

  public downloadXML(obj: any): Observable<any> {

    return this.http.post(`ImpressaoDocumentos/DownloadXML`, obj, httpOptions);
  }

  imprimirHTMLToPDF(obj: ImpressaoHTMLtoPDF): Observable<any> {
    return this.http.post<any>(`ImpressaoDocumentos/ImprimirHtmlToPdf`, obj, httpOptions);
  }

}
